<script>
import { mapActions, mapState } from 'vuex';
import bem from '@/utils/bem';
import columns from '@/pages/enhance/columns';
import PageHeader from '@/components/ux/pageHeader/page-header.vue';
import ChangeProduct from '@/components/modals/Change-product.vue';
import EnhanceWizard from '@/components/wizards/enhance/Enhance-wizard.vue';

const b = bem('enhance-page');
export default {
  data() {
    return {
      productColumns: [],
      columns: columns(),
      title: '',
      selectedId: null,
      isShow: false,
      isShowNew: false,
      isShowWizard: false,
      productInfo: {},
    };
  },
  components: {
    EnhanceWizard,
    PageHeader,
    ChangeProduct,
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    ...mapActions({
      getProductsAction: 'products/getProducts',
      updateProductAction: 'products/updateProduct',
      getCompaniesAction: 'companies/getCompanies',
    }),
    getCompanyName(record) {
      if (!record.customInfo) return '-';
      try {
        const customInfo = JSON.parse(record.customInfo);
        const companyId = customInfo?.company?.companyId;
        if (!companyId) return '-';
        const company = this.companies.find((c) => c.id === companyId);
        return company?.displayName || '-';
      } catch (e) {
        return '-';
      }
    },
    ...mapState({
      isProductsLoaded: (state) => state.products.isProductsLoaded,
    }),
    onUpdate(value) {
      const newValue = {
        id: value.id,
        displayName: value.displayName,
        displayText: value.displayText,
        disclaimer: value.disclaimer,
        price: value.price,
        additionalDiscount: value.additionalDiscount,
        isTaxApplied: value.isTaxApplied,
        isToggle: value.isToggle,
        isMainOption: value.isMainOption,
        visible: value.visible,
        dependQuantityProductIds: value.dependQuantityProductIds,
        type: 'enhance',
      };
      this.updateProductAction(newValue);
    },
    showModal(record) {
      this.selectedId = record.id;
      this.isShow = true;
    },
    showWizardToggle() {
      this.isShowWizard = !this.isShowWizard;
    },
    showNewModal() {
      this.isShowNew = true;
    },
  },
  async mounted() {
    await this.getCompaniesAction({ limit: 1000, offset: 0 });
    this.getProductsAction('enhance');
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.products.isLoading,
      isProductsLoaded: (state) => state.products.isProductsLoaded,
      productList: (state) => state.products.productList,
      companies: (state) => state.companies.companies,
    }),
  },
  watch: {
    isProductsLoaded(newValue, oldValue) {
      if (!oldValue && newValue) {
        const { type } = this.$route.params;

        const photoRestorationProduct = this.productList.find(
          (product) => product.name === 'photo_restoration',
        );

        if (photoRestorationProduct) {
          this.productInfo = photoRestorationProduct;
          const filteredOptions = (photoRestorationProduct.options || [])
            .filter(
              (option) => option.name !== 'enhance_prints' && option.name !== 'easy_scan_ship_kit',
            )
            .sort((a, с) => a.index - с.index);

          const { options, ...productWithoutOptions } = photoRestorationProduct;
          this.productColumns = [productWithoutOptions, ...filteredOptions];
        } else {
          this.productInfo = {};
          this.productColumns = [];
        }

        this.title = type.charAt(0).toUpperCase() + type.slice(1).replaceAll('_', ' ');
      }
    },
  },
};
</script>

<template>
  <PageHeader :title="title"/>
  <div :class="b()">
    <div :class="b('button', { new: true })">
      <a-button v-if="!isShowWizard" type="primary" @click="showNewModal()">
        Create new
      </a-button>
      <ChangeProduct
        v-if="isShowNew"
        v-model:show="isShowNew"
        :isShow="isShowNew"
        :full-product="productInfo"
        :isNewProduct="true"
        button-text="Create"
        title="Create product"
        type="enhance"
      />
    </div>
    <div :class="b('product-info')" v-if="!isShowWizard">
      <a-table
          :columns="columns"
          :data-source="productColumns"
          :pagination="false"
      >
        <template #bodyCell="{ column, text, record }">
          <template v-if="column.dataIndex === 'isTaxApplied'">
            <a-switch
                :checked="text"
                @change="onUpdate({...record, isTaxApplied: !text})">
            </a-switch>
          </template>
          <template v-if="column.dataIndex === 'isToggle'">
            <a-switch
                :checked="text"
                @change="onUpdate({...record, isToggle: !text})">
            </a-switch>
          </template>
          <template v-if="column.dataIndex === 'isMainOption'">
            <a-switch
                :checked="text"
                @change="onUpdate({...record, isMainOption: !text})">
            </a-switch>
          </template>
          <template v-if="column.dataIndex === 'visible'">
            <a-switch
              :checked="text"
              @change="onUpdate({...record, visible: !text})">
            </a-switch>
          </template>
          <template v-else-if="column.dataIndex === 'company'">
            {{ getCompanyName(record) }}
          </template>
          <template v-else-if="column.dataIndex === 'actions'">
            <div :class="b('buttons')">
              <div :class="b('button')">
                <a-button type="primary" @click="showModal(record)">
                  Edit
                </a-button>
                <div v-if="isShow && selectedId === record.id">
                  <ChangeProduct
                    v-model:show="isShow"
                    :isShow="isShow && selectedId === record.id"
                    :product="record"
                    :full-product="productInfo"
                    :available-options="productColumns"
                    :isNewProduct="false"
                    button-text="Edit"
                    title="Change product"
                    type="enhance"
                  />
                </div>
              </div>
            </div>
          </template>
        </template>
      </a-table>
    </div>
    <div :class="b('wizard')" v-else>
      <EnhanceWizard :product-name="$route.params.type" :products="productColumns" />
    </div>
    <div :class="b('top-buttons')">
      <a-button type="primary" @click="showWizardToggle()">
        {{ isShowWizard ? 'Product info' : 'Product wizard' }}
      </a-button>
    </div>
  </div>
</template>

<style src="./style.scss" scoped lang="scss"></style>
